import TableHeader from '@/components/table/tableHeader';
import { ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';

import { FatSeekingInterestPageInvestmentQuery } from '@/__generated__/graphql';
import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import { columns } from '../constants';
import { IInvestmentEntity } from '../types';
import MobileTable from './mobileTable';
import TableBody from './tableBody';

interface InvestorsTableProps {
  sort: ISort;
  loading: boolean;
  listInvestmentEntity: IInvestmentEntity[];
  investment: FatSeekingInterestPageInvestmentQuery['Investment'] | null;
  setSort: (value: ISort) => void;
  selectRow: (row: any) => void;
  selectAllRows: (isChecked: boolean) => void;
  openModalWindow: (type: string, row: IInvestmentEntity) => void;
  openMobileModal: (data: IInvestmentEntity, modalType: string) => void;
  openInvestorDetailsPage: ({ investorId, entityId, isGroup }: { investorId: string; entityId?: string; isGroup?: boolean }) => Promise<void>;
}

const InvestorsTable = ({
  sort,
  loading,
  listInvestmentEntity,
  investment,
  setSort,
  selectRow,
  selectAllRows,
  openModalWindow,
  openMobileModal,
  openInvestorDetailsPage
}: InvestorsTableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>
          {loading ? (
            <Loader />
          ) : (
            <MobileTable
              listInvestmentEntity={listInvestmentEntity}
              openMobileModal={openMobileModal}
              openInvestorDetailsPage={openInvestorDetailsPage}
            />
          )}
        </>
      ) : (
        <>
          <TableHeader
            refetch={() => null as any}
            columns={columns}
            savedSort={sort}
            savedSetSort={setSort}
            checkBox={{
              checked: listInvestmentEntity.every((row) => row.checked) && !!listInvestmentEntity.length,
              onChange: selectAllRows,
              show: true
            }}
          />
          <TableBodyWrapper>
            {loading ? (
              <Loader />
            ) : (
              <TableBody
                listInvestmentEntity={listInvestmentEntity}
                investment={investment}
                openModalWindow={openModalWindow}
                selectRow={selectRow}
                openInvestorDetailsPage={openInvestorDetailsPage}
              />
            )}
          </TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default InvestorsTable;
